import React from 'react';
import AdminStatCard from './ui/AdminStatCard';
import SecurityStatusPill from './ui/SecurityStatusPill';

export default function SecurityMetricsGrid({ dashboardData }) {
  const dbOnline = dashboardData.systemHealth?.databaseConnected;

  return (
    <div className="vx-sec-grid vx-sec-grid--metrics">
      <AdminStatCard
        label="Total events (24h)"
        value={dashboardData.totalEvents || 0}
        hint="Security events"
      />
      <AdminStatCard
        label="Critical events"
        value={dashboardData.severityCounts?.CRITICAL || 0}
        hint="Immediate attention"
        valueClassName="vx-sec-stat-value--critical"
      />
      <AdminStatCard
        label="Blocked IPs"
        value={dashboardData.blockedIPs?.length || 0}
        hint="Currently blocked"
      />
      <AdminStatCard
        label="System health"
        value={<SecurityStatusPill active={dbOnline} activeLabel="Online" inactiveLabel="Offline" />}
        hint={dbOnline ? 'Database connected' : 'Database offline'}
        valueClassName="vx-sec-stat-value--pill"
      />
    </div>
  );
}
